import React from 'react'

function Position() {
  return (
   <>
   <h2>Position</h2>
   <p>position relative</p>
   <code>rel</code>
   <p>position absolute</p>
   <code>abs</code>
   <p>position fixed</p>
   <code>fx</code>
   <p>position static</p>
   <code>stc</code>
   <p>position sticky</p>
   <code>stky</code>
   </>
  )
}

export default Position